import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, ReferenceLine
} from 'recharts';


export class PropertyChartLine extends PureComponent {

    // TODO:
    // GOAL!

    buildData() {
        var data = [];
        var yearsToGoal = this.props.yearsToGoal;

        var spvTotal = 0; //(this.props.spv + this.props.additionalAnnualInvestment);
        var personalTotal = 0; //(this.props.personal + this.props.additionalAnnualInvestment);

        for (var i = 0; i <= yearsToGoal; i++) {
            if (i !== 0) {
                spvTotal += (this.props.spv + this.props.additionalAnnualInvestment);
                personalTotal += (this.props.personal + this.props.additionalAnnualInvestment);
            }
            

            var point = { year: (i === 1 ? i + " year" : i + " years"), spv: spvTotal, personal: personalTotal };
            data.push(point);
        }

        return data;
    }

    render() {
        return (
            <ResponsiveContainer width="100%">

                <LineChart
                    data={this.buildData()}
                    margin={{ top: 20 }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="year" />
                    <YAxis tickFormatter={(value) => (new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(value / 1000) + "k")}/>
                    {/*Fix highlighting on chart when there's no data*/}
                    {this.props.spv || this.props.personal ? <Tooltip formatter={(value) => (new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(value / 1000) + "k")} /> : <Tooltip cursor={{ fill: 'transparent' }} />}
                    <Legend />
                    {this.props.target > 0 &&
                        <ReferenceLine y={this.props.target} label={(new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumFractionDigits: 0, minimumFractionDigits: 0 }).format(this.props.target / 1000) + "k")} stroke="green" />
                    }
                    <Line type="monotone" dataKey="spv" name="Company held" stroke="#440099" activeDot={{ r: 8 }} />
                    <Line type="monotone" dataKey="personal" name="Personally held" stroke="#BD9B60" />
                </LineChart>
            </ResponsiveContainer>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Features/PropertyCalculator/Components/PropertyChartLine.jsx